const id = {
  // Navbar
  nav_home: "Beranda",
  nav_about: "Tentang Paman Tenten",
  nav_services: "Layanan & Harga",
  nav_flow: "Alur Layanan",
  nav_testimonials: "Testimoni",
  nav_faq: "FAQ",
  nav_contact: "Hubungi Kami",
  nav_cta: "Pesan Konsultasi Nama",
  nav_subtitle: "Konsultasi Nama · Okinawa",
  nav_title: "Kantor Paman Tenten",

  // Hero
  hero_headline1: "Di tengah ketenangan",
  hero_headline2: "pulau Okinawa",
  hero_headline3: "kami mendengarkan",
  hero_headline4: "suara dari nama Anda",
  hero_body: "Jadwal konsultasi nama sering penuh berbulan-bulan sebelumnya\nSetiap bulan saya langsung pergi ke pulau Okinawa\nuntuk menyampaikan nama Anda kepada sang ahli",
  hero_pill1: "Tanpa ganti nama",
  hero_pill2: "100% online",
  hero_pill3: "Hasil dalam 1 bulan",
  hero_pill4: "100 kuota per bulan",
  hero_btn_apply: "Pesan Konsultasi Nama",
  hero_btn_services: "Lihat Layanan",
  hero_scroll: "Gulir ke bawah",

  // About
  about_heading: "Tentang Paman Tenten",
  about_intro: "Di <strong>Pulau Ikei</strong> yang tenang di tengah laut hangat Okinawa\nada seorang pria yang menyalakan cahaya kecil untuk setiap nama\nOrang-orang dengan penuh kasih memanggilnya <strong>\"Paman Tenten\"</strong>",
  about_block1_label: "Dari pegawai bank menjadi ahli konsultasi nama",
  about_block1_text: "Paman Tenten dulunya adalah pegawai bank\nBerkat ketekunannya, ia menjadi <strong>kepala cabang termuda</strong> di perusahaan\nMelalui banyak pertemuan dengan orang-orang, sebuah pertanyaan muncul dalam hatinya",
  about_block1_quote: "\"Mengapa sebagian orang tampak memiliki angin yang mendorong mereka maju meski bekerja sama kerasnya?\"",
  about_block1_sub: "Pertanyaan kecil itu menjadi awal dari sebuah penemuan besar",
  about_block2_label: "Kearifan kuno dan cahaya ketenangan",
  about_block2_text: "Ia mendedikasikan seluruh waktu luangnya untuk mempelajari buku-buku kuno tentang konsultasi nama, meneliti secara mendalam karakter Kanji tradisional dan aliran bunyi",
  about_block2_text2: "Ia menyadari bahwa <strong>\"tanda tenten dapat dengan lembut menyesuaikan aliran nama\"</strong>",
  about_block2_sub: "Ini bukan sihir yang dramatis, bukan formula kesuksesan yang ajaib\nMelainkan jalan lembut yang membantu cahaya dalam diri Anda bersinar lebih terang",
  about_block3_label: "Dari mulut ke mulut — Sudah menunggu 6 bulan",
  about_block3_text: "Kehangatan dalam cara konsultasinya menyebar dari mulut ke mulut, dan kini <strong>pertanyaan terus berdatangan tanpa henti dari berbagai penjuru</strong>\nIa memperlakukan semua orang dengan hati yang sama, terkenal atau tidak\nMeletakkan tangan pada setiap nama dan menemani kehidupan setiap orang\nItulah cara Paman Tenten",

  // Gallery
  gallery_heading: "Galeri Foto",
  gallery_sub: "Okinawa · Pulau Ikei",

  // Services
  services_heading: "Layanan & Harga",
  services_note1: "※ Semua paket sudah termasuk biaya konsultasi ahli dan biaya perwakilan",
  services_note2: "※ Tidak ada biaya tambahan, Anda bisa tenang",
  services_tab1: "Nama Pribadi",
  services_tab2: "Nama Bisnis",
  services_tab3: "Nama Hewan Peliharaan",
  services_tab1_en: "Personal Name",
  services_tab2_en: "Business Name",
  services_tab3_en: "Pet Name",
  services_tab1_desc: "Kami dengan lembut mempertimbangkan perkembangan, lingkungan, dan pergerakan jiwa Anda, lalu menambahkan tanda tenten yang paling sesuai",
  services_tab2_desc: "Membawa angin segar untuk tantangan baru, menyesuaikan aliran bisnis Anda dengan lembut",
  services_tab3_desc: "Untuk anggota keluarga yang selalu menemani Anda, berikan nama yang penuh kedamaian dan kehangatan",
  services_row1_target1: "Usia 16 tahun ke atas",
  services_row1_target2: "Usia 4-15 tahun",
  services_row1_target3: "Usia 0-3 tahun",
  services_row2_target1: "Nama merek / Perusahaan / Toko",
  services_row3_target1: "Nama hewan peliharaan",
  services_col_target: "Target",
  services_col_price: "Harga (sudah termasuk pajak)",
  services_cta: "Pesan layanan ini",
  services_includes_title: "Termasuk dalam harga (semua)",
  services_inc1: "Konsultasi nama",
  services_inc2: "Saran tanda tenten terbaik",
  services_inc3: "Pengiriman kartu ukuran kartu nama (gratis jika diinginkan)",
  services_inc4: "Saran keberuntungan",
  services_inc5: "Foto digital kartu nama",
  services_includes_note: "Tujuan konsultasi adalah dengan lembut membangkitkan keajaiban yang sudah ada dalam nama Anda",
  services_payment_title: "Metode pembayaran",
  services_payment_method: "Transfer bank (pembayaran di muka)",
  services_payment_desc: "Setelah mendaftar, kami akan memberikan informasi rekening bank\nKetika pembayaran selesai, aliran keberuntungan akan mulai berkumpul dengan tenang",
  services_first_title: "Untuk pertama kali",
  services_first_desc: "Merasa tidak yakin adalah hal yang wajar\nPerasaan itu adalah sinyal dari dalam\nbahwa sudah saatnya memulai perubahan yang lembut",
  services_first_cta: "Mulai dengan konsultasi",

  // Flow
  flow_heading: "Alur Layanan",
  flow_step1_title: "Kirim formulir",
  flow_step1_c1: "Isi informasi yang diperlukan dalam formulir khusus",
  flow_step1_c2: "Kami akan merespons dalam 2-3 hari kerja setelah pengiriman",
  flow_step1_c3: "Email akan berisi langkah selanjutnya dan instruksi transfer",
  flow_step2_title: "Transfer biaya konsultasi nama",
  flow_step2_c1: "Transfer biaya konsultasi nama ke rekening yang ditentukan dalam email balasan",
  flow_step2_c2: "Setelah konfirmasi pembayaran, kami akan mulai mempersiapkan sesuai urutan",
  flow_step3_title: "Konfirmasi transfer",
  flow_step3_c1: "Setelah transfer, kirim foto bukti transfer ke alamat yang ditentukan dalam email",
  flow_step3_c2: "Setelah dikonfirmasi, kami akan mengirim pesan \"Pendaftaran selesai\"",
  flow_step3_note: "Tanpa konfirmasi ini, kami tidak dapat memulai konsultasi. Pastikan untuk mengirimkannya",
  flow_step4_title: "Terima hasil konsultasi",
  flow_step4_c1: "Setelah konsultasi selesai, kami akan mengirim foto kartu nama dan tanda tenten melalui email dalam sekitar satu minggu",
  flow_step4_c2: "Kemudian laporan konsultasi detail dan saran keberuntungan akan dikirim melalui email",
  flow_step5_title: "Pengiriman kartu nama (opsional)",
  flow_step5_c1: "Jika diinginkan, kami akan mengirim kartu ukuran kartu nama yang ditulis tangan oleh ahli melalui pos",
  flow_step5_c2: "Mohon isi alamat pos yang tepat di kolom alamat formulir",
  flow_step5_note: "Jika tidak memerlukan kartu, cukup isi nama kota tempat tinggal Anda",
  flow_banner_title: "Semua online, dari mana saja di Jepang",
  flow_banner_desc: "Tidak perlu datang langsung ke Pulau Ikei di Okinawa\nAnda bisa memulai segera tanpa mengubah rutinitas harian",
  flow_banner_cta: "Daftar sekarang",

  // Testimonials
  testimonials_heading: "Testimoni dari Pelanggan",
  testimonials_viewing: "Sedang dilihat",

  // FAQ
  faq_heading: "Pertanyaan yang Sering Diajukan",
  faq_cta_title: "Masih ada pertanyaan lain?",
  faq_cta_desc: "Pertanyaan kecil pun disambut\nPertanyaan yang mungkin Anda rasa sungkan — itulah yang paling ingin kami dengar",
  faq_cta_btn: "Ajukan pertanyaan",

  // CTA Banner
  cta_heading1: "Gratis",
  cta_heading2: "Konsultasi",
  cta_btn: "Pesan sekarang",

  // Contact
  contact_heading: "Hubungi Kami",
  contact_desc: "Kirim permintaan konsultasi nama atau pertanyaan melalui formulir ini. Biasanya kami merespons dalam 2-3 hari kerja",
  contact_address_label: "Alamat",
  contact_address_value: "Tochigi, Jepang (Online · Melayani seluruh negeri)",
  contact_email_label: "Email",
  contact_hours_label: "Jam kerja",
  contact_hours_value: "Sen–Jum 9:00–18:00 (Libur Sab/Min/hari libur)",
  contact_note_title: "Tentang respons",
  contact_note_desc: "Respons mungkin masuk ke folder spam\nJika tidak menerima respons dalam 2-3 hari kerja, silakan hubungi langsung melalui email",
  contact_field_name: "Nama lengkap",
  contact_field_furigana: "Furigana (cara baca nama)",
  contact_field_email: "Alamat email",
  contact_field_phone: "Nomor telepon",
  contact_field_service: "Layanan yang diinginkan",
  contact_field_message: "Pesan",
  contact_placeholder_name: "Budi Santoso",
  contact_placeholder_furigana: "ヤマダ タロウ",
  contact_placeholder_email: "example@mail.com",
  contact_placeholder_phone: "+62 000 0000 0000",
  contact_placeholder_message: "Silakan masukkan nama yang ingin dikonsultasikan atau pertanyaan dan permintaan Anda",
  contact_select_placeholder: "Pilih",
  contact_service1: "Nama pribadi",
  contact_service2: "Nama bisnis",
  contact_service3: "Nama hewan peliharaan",
  contact_service4: "Lainnya / Tanya lebih lanjut",
  contact_submit: "Kirim",
  contact_submitting: "Mengirim...",
  contact_privacy: "Informasi pribadi yang dikirim melalui formulir hanya digunakan untuk layanan konsultasi nama",
  contact_error: "Pengiriman gagal. Silakan coba lagi nanti atau hubungi langsung melalui email",
  contact_err_name: "Silakan masukkan nama lengkap Anda",
  contact_err_email_required: "Silakan masukkan alamat email Anda",
  contact_err_email_invalid: "Silakan masukkan alamat email yang valid",
  contact_err_service: "Silakan pilih layanan",
  contact_err_message_required: "Silakan masukkan pesan",
  contact_err_message_limit: "Pesan tidak boleh melebihi 500 karakter",
  contact_thanks_title: "Pesan telah terkirim",
  contact_thanks_desc: "Terima kasih telah menghubungi kami\nSetelah meninjau pesan Anda, kami akan merespons dalam <strong>2-3 hari kerja</strong>\nMohon tunggu",
  contact_thanks_check1: "Periksa email konfirmasi",
  contact_thanks_check2: "Periksa juga folder spam",
  contact_thanks_check3: "Tunggu respons dalam 2-3 hari kerja",
  contact_thanks_another: "Kirim pesan lain",

  // Footer
  footer_subtitle: "Konsultasi Nama · Okinawa",
  footer_title: "Kantor Paman Tenten",
  footer_desc: "Dari Okinawa ke seluruh negeri, ahli konsultasi nama dengan pengalaman lebih dari 50 tahun membaca takdir tersembunyi dalam nama Anda dengan penuh perhatian",
  footer_contact_title: "Informasi Kontak",
  footer_address_label: "Alamat",
  footer_address_value: "Tochigi, Jepang\n(Online · Melayani seluruh negeri)",
  footer_email_label: "Email",
  footer_hours_label: "Jam kerja",
  footer_hours_value: "Sen–Jum 9:00–18:00\n(Libur Sab/Min/hari libur)",
  footer_nav_title: "Navigasi",
  footer_copyright: "© 2025 Kantor Paman Tenten. Hak cipta dilindungi",
  footer_privacy: "Kebijakan Privasi",
  footer_law: "Hukum Perdagangan Khusus",
  footer_sitemap: "Peta Situs",
};

export default id;
